
const site_data = (query) => {
  return new Promise((resolve) => {
    fetch(`//samandapi.elyssasamsel.com/wp-json/${query}`)
    .then(function(response) {
      if (response.status >= 400) {
        throw new Error("Bad response from server");
      }
      return response.json();
      })
      .then(res => {
        resolve (res)
    });
  })
}

export default {
  site_data,
}


// WEBPACK FOOTER //
// ./src/helpers/util_fetch.js